import PageShell from "@/components/PageShell";

export default function ContactUs() {
  return (
    <PageShell testid="contact-us-page" eyebrow="Contact Us" title="Say Bonjour." updated="26 September 2026">
      <h2>Business details</h2>
      <ul>
        <li>
          <strong>Trade name:</strong> French Pie (Sahil &amp; Co)
        </li>
        <li>
          <strong>Registered legal name:</strong> Sahil Majid Dar — Sole Proprietorship
        </li>
        <li>
          <strong>GSTIN:</strong> 01HBLPD9801F1ZX
        </li>
        <li>
          <strong>FSSAI Registration No.:</strong> 21023418000068
        </li>
        <li>
          <strong>Udyam Registration No.:</strong> UDYAM-JK-21-0075571
        </li>
        <li>
          <strong>Registered business address:</strong> Havells Galaxy, Sector 3, Shamasabad, Bemina, Srinagar,
          Jammu &amp; Kashmir 190018, India
        </li>
        <li>
          <strong>Email:</strong> bemina@frenchpie.co.in
        </li>
        <li>
          <strong>Contact number:</strong> +91 95967 66336
        </li>
        <li>
          <strong>Working hours:</strong> 10:00 AM – 10:00 PM, all days
        </li>
        <li>
          <strong>Website:</strong> www.frenchpie.co.in
        </li>
      </ul>

      <h2>Customer support</h2>
      <p>
        For orders, cancellations, refunds or any question about our bakes, write to{" "}
        <strong>bemina@frenchpie.co.in</strong> or call <strong>+91 95967 66336</strong> between 10:00 AM and 10:00
        PM. A human (flour-dusted) replies to every message, usually within one working day.
      </p>

      <h2>Grievance officer</h2>
      <p>
        Grievances may be raised with the proprietor, Sahil Majid Dar, at{" "}
        <strong>bemina@frenchpie.co.in</strong> or at the registered business address above. We acknowledge every
        complaint within 48 hours and aim to resolve it within 7 working days.
      </p>
    </PageShell>
  );
}
